import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { MainTimesheet } from "../../class/main-timesheet";
import { Timesheet } from "../../class/timesheet";
import { TimesheetSummaryModel } from "src/app/class/timesheet-summary.model";

@Injectable({
  providedIn: "root",
})
export class VerifyTimesheetViewService {
  constructor(private http: HttpClient) {}

getMandayProjectYear(year: number, status: string): Observable<Blob> {
  return this.http.get(
    `${environment.url}/apiTimesheet/report-project-year/${year}?status=${status}`,
    { responseType: 'blob' } 
  );
}

getDistinctYear(): Observable<any> {
    return this.http.get(
      `${environment.url}/apiTimesheet/distinct-year`
    );
  }

  listtimesheet(id: number): Observable<any> {
    return this.http.get(
      `${environment.url}/apiTimesheet/gettimesheetbyid/` + id
    );
  }
  fetchTimesheetFromRemote(): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getTimesheetAll`
    );
  }

  getTimesheetByEmployeeId(employeeId: number): Observable<TimesheetSummaryModel[]> {
    let params = new HttpParams();
    params = params.append("employeeId", employeeId);
    return this.http.get<TimesheetSummaryModel[]>(
      `${environment.url}/apiTimesheet/getProjectCountByEmployeeId`,
      { params: params }
    );
  }


  fetchMainTimesheetList(): Observable<any> {
    return this.http.get<any>(`${environment.url}/apiMainTimeSheet/getAll`);
  }

  deleteTimesheetByIdFromRemote(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.url}/apiTimesheet/deleteById/` + id
    );
  }

  updatemtimesheet(maintimesheet: MainTimesheet): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiMainTimeSheet/upMainTimesheet`,
      maintimesheet
    );
  }

  updateTimesheetToRemote(timesheet: Timesheet): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiTimesheet/editTimesheet`,
      timesheet
    );
  }

  getTimesheetByPagging(
    pageNo: number,
    pageSize: number,
    maintimesheetId: number,
    keyword: string,
    sortBy: string,
    isAscending: boolean
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("maintimesheetId", maintimesheetId);
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (sortBy != null) {
      params = params.append("sortBy", sortBy);
    }
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getAllTimesheetByNamePaging`,
      { params: params }
    );
  }

  getTimesheetByMainTimesheetAndProjectNameWithPaging(
    pageNo: number,
    pageSize: number,
    maintimesheetId: number,
    projectName: string,
    startTime: any,
    endTime: any,
    date: any,
    sortBy: string,
    isAscending: boolean
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("maintimesheetId", maintimesheetId);
    params = params.append("projectName", projectName);
    if (startTime != null) {
      params = params.append("startTime", startTime);
    }
    if (endTime != null) {
      params = params.append("endTime", endTime);
    }
    if (date != null) {
      params = params.append("date", date);
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (sortBy != null) {
      params = params.append("sortBy", sortBy);
    }
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getTimesheetByMainTimesheetAndProjectNameSortWithPaging`,
      { params: params }
    );
  }

  sumWorkingHoursByName(
    maintimesheetId: number,
    keyword: string
  ): Observable<any> {
    let params = new HttpParams();
    if (maintimesheetId != null) {
      params = params.append("maintimesheetId", maintimesheetId);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    return this.http.get<any>(`${environment.url}/apiTimesheet/sumTimesheet`, {
      params: params,
    });
  }

  //mainTimesheet
  findMainTimesheetById(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/getMainTimesheetById/` + id
    );
  }

  getEmployeeMainTimesheetList(): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/findEmployeeMainTimesheet`
    );
  }

  searchtimesheet(search: string): Observable<any> {
    let params = new HttpParams();
    if (search != null) {
      params = params.append("keyword", search);
    }
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getAllTimesheetByNamePaging`,
      { params: params }
    );
  }

  getProjectNameByMainTimesheetId(maintimesheetId: number): Observable<any> {
    let params = new HttpParams();
    params = params.append("maintimesheetId", maintimesheetId);
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getProjectNameByMainTimesheetId`,
      { params: params }
    );
  }

  getMandayProjectbyYear(year: number): Observable<any> {
    let params = new HttpParams();
    params = params.append("year", year);
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getMandayProjectbyYear`,
      { params: params }
    );
  }

  getMandayProjectbyYearV2(year: number): Observable<any> {
    let params = new HttpParams();
    params = params.append("year", year);
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getMandayProjectbyYearV2`,
      { params: params }
    );
  }

  // Export Manday methods
  exportManday(year: number, month: number): Observable<Blob> {
    return this.http.get(
      `${environment.url}/apiTimesheet/export-manday/${year}/${month}`,
      { responseType: 'blob' }
    );
  }

  /**
   * Export monthly leave report for all employees (HR only)
   */
  exportLeaveReportAll(year: number, month: number): Observable<Blob> {
    return this.http.get(
      `${environment.url}/apiLeave/export/monthly/all`,
      { 
        params: new HttpParams()
          .set('year', year.toString())
          .set('month', month.toString()),
        responseType: 'blob' 
      }
    );
  }

  /**
   * Export monthly leave report for team members (Manager only)
   */
  exportLeaveReportByManager(
    year: number, 
    month: number, 
    managerId: number
  ): Observable<Blob> {
    return this.http.get(
      `${environment.url}/apiLeave/export/monthly/team/${managerId}`,
      { 
        params: new HttpParams()
          .set('year', year.toString())
          .set('month', month.toString()),
        responseType: 'blob' 
      }
    );
  }

exportAnnualLeaveReport(): Observable<Blob> {
  return this.http.get(
    `${environment.url}/apiLeave/export/annual`,
    { responseType: 'blob' }
  );
}


exportAnnualLeaveReportByManager(managerId: number): Observable<Blob> {
  return this.http.get(
    `${environment.url}/apiLeave/export/leave/team/${managerId}`,
    { responseType: 'blob' }
  );
}

  exportMandayProjectManager(year: number, month: number, projectManagerId?: number): Observable<Blob> {
    let params = new HttpParams();
    if (projectManagerId) {
      params = params.append('projectManagerId', projectManagerId.toString());
    }
    return this.http.get(
      `${environment.url}/apiTimesheet/export-manday/pm/${year}/${month}/${projectManagerId}`,
      { params: params, responseType: 'blob' }
    );
  }

  // Export Site Cost methods
  exportSiteCost(year: number, month: number): Observable<Blob> {
    return this.http.get(
      `${environment.url}/apiTimesheet/export-site-cost/${year}/${month}`,
      { responseType: 'blob' }
    );
  }

  exportSiteCostProjectManager(year: number, month: number, projectManagerId?: number): Observable<Blob> {
    let params = new HttpParams();
    if (projectManagerId) {
      params = params.append('projectManagerId', projectManagerId.toString());
    }
    return this.http.get(
      `${environment.url}/apiTimesheet/export-site-cost/pm/${year}/${month}/${projectManagerId}`,
      { params: params, responseType: 'blob' }
    );
  }
}
